import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import {Space} from "../client/SpaceAPIClient";


class PublicSpaceState {
    constructor(
        spaceId,
        loadingState,
        space) {
        this.spaceId = spaceId;
        this.loadingState = loadingState;
        this.space = space;
    }

    equals(other) {
        return this.space.equals(other.space) &&
            this.loadingState === other.loadingState &&
            this.loadingState === other.loadingState;
    }
}

class ImmutablePublicSpaceStateBuilder {

    constructor() {
        this.spaceId = 0;
        this.loadingState = LoadingStates.INITIALIZED;
        this.space = new Space();
    }

    setFromState(state) {
        return this.setSpaceId(state.spaceId)
            .setSpace(state.space)
            .setLoadingState(state.loadingState);
    }

    setSpaceId(spaceId) {
        this.spaceId = spaceId;
        return this;
    }

    setSpace(space) {
        this.space = space;
        return this;
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }


    build() {
        return Object.freeze(new PublicSpaceState(this.spaceId, this.loadingState, this.space));
    }
}


class PublicSpaceStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.PUBLIC_SPACE_STORE_UPDATE, ImmutablePublicSpaceStateBuilder);
        this.subscribeToEvent(ActionResultEvents.PUBLIC_SPACE_LOADED, this.handlePublicSpaceLoaded);
        this.subscribeToEvent(ActionResultEvents.PUBLIC_SPACE_NOT_FOUND, this.handlePublicSpaceNotFound);
        this.subscribeToEvent(UIInteractionEvents.PUBLIC_SPACE_SET_SPACE_ID, this.handleSetSpaceId);
    }

    handlePublicSpaceNotFound = (topic, data) => {
        return new ImmutablePublicSpaceStateBuilder()
            .setLoadingState(LoadingStates.FAILED_TO_LOAD)
            .build();
    };

    handlePublicSpaceLoaded = (topic, data) => {
        return new ImmutablePublicSpaceStateBuilder()
            .setFromState(this.state)
            .setSpace(data)
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .build();
    };

    handleSetSpaceId = (topic, data) => {
        return new ImmutablePublicSpaceStateBuilder()
            .setSpaceId(data.id)
            .setLoadingState(LoadingStates.LOADING)
            .build();
    }

}

export default new PublicSpaceStore();